import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ConfigContext } from "../../../Context/ConfigContext";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { CartsContext } from "../../../Context/CartsContext";
import { OverlayLoader } from "../../../Components/Shimmers";
import { axiosGet } from "../../../Apis/axiosMethods";

export default function BasketPayment() {
    const { paymentMethod, setPaymentMethod, apiB2BURL, token, currency } = useContext(ConfigContext);
    const { t } = useTranslation();

    useEffect(() => {
        GetAddresses();
    }, []);

    const location = useLocation()
    const { cartData } = useContext(CartsContext)

    const GetAddresses = async () => {
        try {
            const business_id = localStorage.getItem("business_id");

            const response = await axiosGet(`/Users/GetAddresses?business_id=${business_id}`,);

            const data = response.data;

            if (data.success) {
                if (data.data.length > 0) {
                    // find default_address = 1 
                    const defaultAddress = data.data.find(address => address.default_address === '1');

                    if (defaultAddress) {
                        // console.log("Default Address Found:", defaultAddress);
                    } else {
                        // console.log("No Default Address Found");
                        window.location = '/basket/address'
                    }
                } else {
                    window.location = '/basket/address'
                }

            } else {
                window.location = '/basket/address'
            }
        } catch (error) {
            window.location = '/basket/address'
        }
    };

    const handlePaymentChange = (method) => {
        if (method === 'Credit' || method === 'credit') {
            if (creditOption === true) {
                setPaymentMethod(method);
            }
            return false;
        }
        setPaymentMethod(method);
    }

    const dir = localStorage.getItem('dir');
    const [loading, setLoading] = useState(true);

    const [isCredit, setIsCredit] = useState(false);
    const [CODApplicable, setCODApplicable] = useState(false);
    const [creditLimit, setCreditLimit] = useState(0);
    const [creditBalance, setCreditBalance] = useState(0);
    const [creditOption, setCreditOption] = useState(false);


    const [isTestingType, setIsTestingType] = useState(false);

    const data = () => {
        setCreditOption(cartData?.credit_option);
        setCreditBalance(cartData?.business_credit_balance);
        setCreditLimit(cartData?.business_credit_limit);
    }

    useEffect(() => {
        data()
    }, [location, creditOption, dir, apiB2BURL, cartData])



    const GetBusinessInfo = async () => {
        try {

            setLoading(true);

            const business_id = localStorage.getItem("business_id");

            const response = await axiosGet(`/Users/GetBusinessInfo?business_id=${business_id}`);

            const data = response.data;

            setCreditOption(cartData?.credit_option);
            setCreditBalance(cartData?.business_credit_balance);
            setCreditLimit(cartData?.business_credit_limit);

            if (data.success) {
                setCODApplicable(data.data[0].business_cod_status === 1 ? true : false);
                setIsCredit(data?.data[0]?.business_credit_status === 1 ? true : false)
                setIsTestingType(data?.data[0]?.business_account_type === 1 ? true : false)

            } else {
                console.log("Error While Fetching Business Info", data.message);
            }
        } catch (error) {
            console.log("Error fetching business info:", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        GetBusinessInfo();
    }, [location]);

    return (
        <>
            {
                loading ?
                    <div style={{ height: "70vh" }}>
                        <OverlayLoader />
                    </div>
                    :
                    <main className="main" dir={dir} style={{ textAlign: dir === 'rtl' ? 'right' : '' }}>
                        <div className="row justify-content-center mt-2">
                            <div className="col-sm-8" style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                                <span className="product-description__item-title">{t("please_convenient_payment")}</span>

                                <div id="accordion2" className="mt-2">
                                    {
                                        (isTestingType || !isCredit) &&
                                        (currency || "").toLowerCase() !== "usd" &&
                                        <div className="card card-accordion accordion-boxed" style={{ paddingRight: '50px' }} >
                                            <div onClick={() => handlePaymentChange('online')} style={{ backgroundColor: '#FFF', textAlign: 'left', height: '100px' }} className="card-header collapsed" data-toggle="collapse" data-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                                                <div className="row" style={{ marginTop: '25px' }}>
                                                    <div className="col-lg-1">
                                                        <input
                                                            type="radio"
                                                            name="paymentMethod"
                                                            checked={paymentMethod === 'online'}
                                                            onChange={() => handlePaymentChange('online')}
                                                        />
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <img src="/assets/images/payment/visa.svg" alt="Visa" className="payment-icon" style={{ width: '40px', display: 'inline-block' }} />
                                                        <img src="/assets/images/payment/mc.svg" alt="Mastercard" className="payment-icon" style={{ width: '40px', display: 'inline-block' }} />
                                                        <img src="/assets/images/payment/ae.svg" alt="American Express" className="payment-icon" style={{ width: '40px', display: 'inline-block' }} />
                                                    </div>
                                                    <div className="col-lg-6" style={{ textAlign: dir === 'rtl' ? 'right' : '' }}>
                                                        <span className="ml-5" style={{ fontSize: '13px', fontWeight: 500 }}>{t('online_payments_recommended')}</span>
                                                    </div>
                                                </div>

                                            </div>

                                            <div id="collapse4" className="collapse" data-parent="#accordion2">
                                                <p>
                                                    <span className="alert alert-default" style={{ backgroundColor: '#f9fafb' }}>
                                                        <i className="fas fa-lock" style={{ color: '#000', marginTop: '-60px', fontSize: '16px' }} ></i> {t('we_care_about_your_security')}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    }

                                    {
                                        (isTestingType || !isCredit) &&
                                        <div className="card card-accordion accordion-boxed" style={{ paddingRight: '50px' }} >
                                            <div onClick={() => handlePaymentChange('bank')} style={{ backgroundColor: '#FFF', textAlign: 'left', height: '100px' }} className="card-header collapsed" data-toggle="collapse" data-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                                                <div className="row" style={{ marginTop: '25px' }}>
                                                    <div className="col-lg-1">
                                                        <input type="radio" name="paymentMethod" checked={paymentMethod === 'bank' ? true : false} onChange={() => handlePaymentChange('bank')} />
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <img src="/assets/images/payment/bank_transfer.svg" alt="Bank Transfer" className="payment-icon" style={{ width: '60px', display: 'inline-block' }} />
                                                    </div>
                                                    <div className="col-lg-6" style={{ textAlign: dir === 'rtl' ? 'right' : '' }}>
                                                        <span className="ml-5" style={{ fontSize: '13px', fontWeight: 500 }}>{t('bank_transfer')}</span>
                                                    </div>
                                                </div>

                                            </div>

                                            <div id="collapse5" className="collapse" data-parent="#accordion2">
                                                <p>
                                                    <span className="alert alert-default" style={{ backgroundColor: '#f9fafb' }}>{t('an_easy_money')}</span>
                                                </p>
                                            </div>
                                        </div>
                                    }

                                    {
                                        currency?.toLowerCase() !== "usd" &&
                                        <div className="card card-accordion accordion-boxed"
                                            style={{
                                                paddingRight: "50px",
                                                opacity: isCredit && creditOption ? 1 : 0.5,
                                                cursor: isCredit && creditOption ? "pointer" : "not-allowed",
                                                pointerEvents: isCredit && creditOption ? "auto" : "none",
                                            }}
                                        >
                                            <div
                                                onClick={() => handlePaymentChange('credit')}
                                                style={{
                                                    backgroundColor: '#FFF',
                                                    textAlign: 'left',
                                                    height: '100px'
                                                }}
                                                className="card-header collapsed"
                                                data-toggle="collapse"
                                                data-target="#collapseTabby"
                                                aria-expanded="false"
                                                aria-controls="collapseTabby"
                                            >
                                                <div className="row" style={{ marginTop: '25px' }}>
                                                    <div className="col-lg-1">
                                                        <input
                                                            type="radio"
                                                            name="paymentMethod"
                                                            checked={paymentMethod === 'credit'}
                                                            onChange={() => handlePaymentChange('credit')}
                                                        />
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <img src="/assets/images/credit.png" style={{ width: '50px', marginTop: '-6px' }} />
                                                    </div>
                                                    <div className="col-lg-6" style={{ textAlign: dir === 'rtl' ? 'right' : '' }}>
                                                        <span className="ml-5" style={{ fontSize: '13px', fontWeight: 500 }}>Shop now pay later using credit balance</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="collapseTabby" className="collapse" data-parent="#accordion2">
                                                <p>
                                                    <span className="alert alert-default" style={{ backgroundColor: '#f9fafb' }}>
                                                        Your credit balance is  <span> </span>   <span className="mr-2"><b>:  AED {creditBalance}</b></span> & your total credit limit is <b>:  AED {creditLimit}</b>
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    }

                                    {(isTestingType || !isCredit) && CODApplicable &&
                                        (currency || "").toLowerCase() !== "usd" &&
                                        <div className="card card-accordion accordion-boxed" style={{ paddingRight: '50px' }} >
                                            <div
                                                onClick={() => handlePaymentChange('cod')}
                                                style={{ backgroundColor: '#FFF', textAlign: 'left', height: '100px' }}
                                                className="card-header collapsed"
                                                data-toggle="collapse"
                                                data-target="#collapse6"
                                                aria-expanded="false"
                                                aria-controls="collapse6"
                                            >
                                                <div className="row" style={{ marginTop: '25px' }}>
                                                    <div className="col-lg-1">
                                                        <input
                                                            type="radio"
                                                            name="paymentMethod"
                                                            checked={paymentMethod === 'cod'}
                                                            onChange={() => handlePaymentChange('cod')}
                                                        />
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <img
                                                            src="/assets/images/payment/cod.png"
                                                            alt="Cash on Delivery"
                                                            className="payment-icon"
                                                            style={{ width: '80px', display: 'inline-block' }}
                                                        />
                                                    </div>
                                                    <div className="col-lg-6" style={{ textAlign: dir === 'rtl' ? 'right' : '' }}>
                                                        <span className="ml-5" style={{ fontSize: '13px', fontWeight: 500 }}>
                                                            {t('cash_on_delivery')}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="collapse6" className="collapse" data-parent="#accordion2">
                                                <p>
                                                    <span className="alert alert-default" style={{ backgroundColor: '#f9fafb' }}>
                                                        {t('pay_with_cash_when')}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    }
                                </div>

                                <center>
                                    <button
                                        onClick={() => window.location = '/basket/confirm'}
                                        className="btn btn-primary btn-lg mt-2"
                                        style={{ width: '300px' }}
                                        disabled={!paymentMethod}
                                    >{t('next')}</button></center>
                            </div>
                        </div>
                    </main>

            }
        </>
    )
}